
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/push",
      function () {
        return require("private-next-pages/push/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/push"])
      });
    }
  